export enum PaymentOperationResultEnum {
	pending = 0,
	completedSuccesfully = 1,
	completedUnsuccesfully = 2,
	cancelled = 3,
	error = 4,
	unknown = 5
}
